import { create } from "zustand";
// Helper function to find project in tree
const findProjectInTree = (id, root) => {
    if (root?._id === id)
        return root;
    if (!root?.subProjects)
        return null;
    for (const sub of root?.subProjects) {
        const found = findProjectInTree(id, sub);
        if (found)
            return found;
    }
    return null;
};
const useProjectStore = create((set, get) => ({
    selectedProject: null,
    projects: [], // Initialize the projects array
    allProjects: [],
    searchTerm: "",
    sortOrder: "date-desc",
    showProjectPage: false,
    showForm: false,
    navigationHistory: [],
    isEditingProjectName: false,
    // selectedFile: "", // Initialize the selected file state
    selectedFile: null, // Initialize the selected file state
    previewDialogVisible: false, // Initialize the dialog visibility state
    dialogVisible: false,
    setSelectedProject: (project) => set({ selectedProject: project }),
    setProjects: (projects) => set({ projects }),
    removeProject: (projectId) => set((state) => ({
        projects: state.projects.filter((p) => p._id !== projectId),
    })),
    setAllProjects: (projects) => set({ allProjects: projects }),
    setSearchTerm: (term) => set({ searchTerm: term }),
    setSortOrder: (order) => set({ sortOrder: order }),
    setShowProjectPage: (show) => set({ showProjectPage: show }),
    setShowForm: (show) => set({ showForm: show }),
    setIsEditingProjectName: (isEditing) => set({ isEditingProjectName: isEditing }),
    pushToHistory: (project) => set((state) => ({
        navigationHistory: [...state.navigationHistory, project],
    })),
    popFromHistory: () => {
        const state = get();
        const newHistory = [...state.navigationHistory];
        const poppedItem = newHistory.pop();
        if (newHistory.length === 0) {
            set({
                navigationHistory: [],
                selectedProject: null,
                showProjectPage: false,
            });
        }
        else {
            set({
                navigationHistory: newHistory,
                selectedProject: newHistory[newHistory.length - 1],
            });
        }
        return poppedItem;
    },
    clearHistory: () => set({ navigationHistory: [] }),
    // setSelectedFile: (file) => set({ selectedFile: file }), // Add setter for selected file
    setSelectedFile: (file) => set({ selectedFile: file }),
    setPreviewDialogVisible: (visible) => set({ previewDialogVisible: visible }), // Add setter for dialog visibility
    setDialogVisible: (visible) => set({ dialogVisible: visible }),
    createSubProject: (parentId, newProject) => {
        set((state) => {
            if (!state.selectedProject)
                return state;
            // Find root project from navigation history
            const rootProject = state.navigationHistory[0];
            const updateProjectTree = (project) => {
                if (project?._id === parentId) {
                    return {
                        ...project,
                        subProjects: [...(project?.subProjects || []), newProject],
                    };
                }
                if (project?.subProjects) {
                    return {
                        ...project,
                        subProjects: project?.subProjects?.map((sub) => updateProjectTree(sub)),
                    };
                }
                return project;
            };
            const updatedRootProject = updateProjectTree(rootProject);
            return {
                selectedProject: newProject,
                navigationHistory: [
                    updatedRootProject,
                    ...state.navigationHistory
                        .slice(1)
                        .map((project) => findProjectInTree(project?._id, updatedRootProject) || project),
                    newProject,
                ],
            };
        });
        return newProject;
    },
    updateProjectName: (projectId, newName) => set((state) => {
        if (!state.selectedProject)
            return state;
        const rootProject = state.navigationHistory[0];
        const updateProjectTree = (project) => {
            if (project?._id === projectId) {
                return { ...project, name: newName };
            }
            if (project?.subProjects) {
                return {
                    ...project,
                    subProjects: project?.subProjects?.map((sub) => updateProjectTree(sub)),
                };
            }
            return project;
        };
        const updatedRootProject = updateProjectTree(rootProject);
        return {
            selectedProject: findProjectInTree(projectId, updatedRootProject) ||
                state.selectedProject,
            navigationHistory: [
                updatedRootProject,
                ...state.navigationHistory
                    .slice(1)
                    .map((project) => findProjectInTree(project?._id, updatedRootProject) || project),
            ],
        };
    }),
    setNavigationHistory: (history) => set({ navigationHistory: history }),
}));
export default useProjectStore;
